export const getDefaultState = () => {
  return {
    marketingAutomations: []
  };
};
